export default __webpack_public_path__ + "static/media/gallery_04.216676d3.jpg";